import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AllInOne from "./components/AllInOne";
import Features from "./components/Features";
import Benefits from "./components/Benefits";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Navbar />
      <main>
        <Hero />
        <AllInOne />
        <Features />
        <Benefits />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
